import ChangeAccountData from "./changeAccountData";

function Settings()
{
	return (<ChangeAccountData />);
}

export default Settings;
